import { useState, useCallback } from 'react';

const useClipboard = () => {
  const [copyMessage, setCopyMessage] = useState('');

  const copyToClipboard = useCallback(async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopyMessage('URLをクリップボードにコピーしました！');
      setTimeout(() => setCopyMessage(''), 3000);
    } catch (err) {
      console.error('Failed to copy: ', err);
      setCopyMessage('コピーに失敗しました。');
      setTimeout(() => setCopyMessage(''), 3000);
    }
  }, []);

  return { copyMessage, copyToClipboard };
};

export default useClipboard;
